<template>
  <el-dialog
    :visible.sync="visible"
    width="420px"
    custom-class="front-auth-dialog"
    append-to-body
    :close-on-click-modal="false"
    :show-close="false"
    @closed="reset"
    @open="alignDialog"
  >
    <button class="dialog-close" type="button" aria-label="关闭" @click="visible = false">
      <i class="el-icon-close"></i>
    </button>

    <div v-if="isForgot" class="auth-panel forgot-panel">
      <h2 class="forgot-title">找回密码</h2>
      <el-form class="auth-form forgot-form" :model="form" @submit.native.prevent="submitForgot">
        <el-form-item label="手机号码">
          <el-input v-model.trim="form.phone" maxlength="11" autocomplete="tel" placeholder="用于登录与接收赛事通知" />
        </el-form-item>
        <el-form-item label="验证码">
          <div class="code-row">
            <el-input v-model.trim="form.code" maxlength="6" autocomplete="one-time-code" placeholder="请输入验证码" />
            <el-button class="code-button" type="default" :loading="codeLoading" :disabled="loading || codeLoading || codeCountdown > 0" @click="sendCode">{{ codeButtonText }}</el-button>
          </div>
        </el-form-item>
        <el-form-item label="设置密码">
          <el-input v-model="form.password" type="password" show-password autocomplete="new-password" placeholder="8–20 位字母与数字组合" />
        </el-form-item>
        <el-form-item label="再次输入">
          <el-input v-model="form.confirmPassword" type="password" show-password autocomplete="new-password" placeholder="8–20 位字母与数字组合" />
        </el-form-item>
        <el-button class="submit-button forgot-submit" type="primary" native-type="submit" :loading="loading">确 定</el-button>
      </el-form>
    </div>

    <div v-else-if="!isRegister" class="auth-panel">
      <div class="auth-heading">
        <img src="/figma/logo.svg" alt="" width="50" height="50">
        <div>
          <h2>欢迎登录</h2>
          <p>登录后即可报名与查看赛事进度</p>
        </div>
      </div>

      <div class="auth-tabs" role="tablist" aria-label="登录方式">
        <button :class="{active: loginMode === 'code'}" type="button" role="tab" :aria-selected="String(loginMode === 'code')" @click="loginMode = 'code'">验证码登录</button>
        <button :class="{active: loginMode === 'password'}" type="button" role="tab" :aria-selected="String(loginMode === 'password')" @click="loginMode = 'password'">密码登录</button>
      </div>

      <el-form class="auth-form" :model="form" @submit.native.prevent="submit">
        <el-form-item :label="loginMode === 'code' ? '手机号码' : '账号'">
          <el-input v-model.trim="form.phone" maxlength="30" autocomplete="username" :placeholder="loginMode === 'code' ? '请输入手机号码' : '请输入手机号账号'" />
        </el-form-item>

        <el-form-item v-if="loginMode === 'code'" label="验证码">
          <div class="code-row">
            <el-input v-model.trim="form.code" maxlength="6" autocomplete="one-time-code" placeholder="请输入短信验证码" />
            <el-button class="code-button" type="default" :loading="codeLoading" :disabled="loading || codeLoading || codeCountdown > 0" @click="sendCode">{{ codeButtonText }}</el-button>
          </div>
        </el-form-item>

        <el-form-item v-else label="密码">
          <el-input v-model="form.password" type="password" show-password autocomplete="current-password" placeholder="请输入密码" />
        </el-form-item>

        <div class="agreement-row">
          <el-checkbox v-model="agreed">
            <span>我已阅读并同意</span><button type="button" class="agreement-link" @click.stop.prevent="showAgreement('USER')">《用户协议》</button><span>、</span><button type="button" class="agreement-link" @click.stop.prevent="showAgreement('PRIVACY')">《隐私政策》</button>
          </el-checkbox>
          <button v-if="loginMode === 'password'" class="forgot-link" type="button" @click="showForgotPassword">忘记密码</button>
        </div>
        <el-button class="submit-button" type="primary" native-type="submit" :loading="loading">登录</el-button>
      </el-form>

      <p class="switch-tip">还没有账号？<button type="button" @click="switchPanel(true)">立即注册</button></p>
    </div>

    <div v-else class="auth-panel register-panel">
      <div class="auth-heading">
        <img src="/figma/logo.svg" alt="" width="50" height="50">
        <div>
          <h2>注册</h2>
          <p>新用户注册</p>
        </div>
      </div>

      <el-form class="auth-form" :model="form" @submit.native.prevent="submit">
        <el-form-item label="手机号码">
          <el-input v-model.trim="form.phone" maxlength="11" autocomplete="tel" placeholder="用于登录与接收赛事通知" />
        </el-form-item>
        <el-form-item label="验证码">
          <div class="code-row">
            <el-input v-model.trim="form.code" maxlength="6" autocomplete="one-time-code" placeholder="请输入验证码" />
            <el-button class="code-button" type="default" :loading="codeLoading" :disabled="loading || codeLoading || codeCountdown > 0" @click="sendCode">{{ codeButtonText }}</el-button>
          </div>
        </el-form-item>
        <el-form-item label="设置密码">
          <el-input v-model="form.password" type="password" show-password autocomplete="new-password" placeholder="8–20 位字母与数字组合" />
        </el-form-item>
        <el-form-item label="再次输入">
          <el-input v-model="form.confirmPassword" type="password" show-password autocomplete="new-password" placeholder="8–20 位字母与数字组合" />
        </el-form-item>
        <div class="agreement-row register-agreement">
          <el-checkbox v-model="agreed">
            <span>我已阅读并同意</span><button type="button" class="agreement-link" @click.stop.prevent="showAgreement('USER')">《用户协议》</button><span>、</span><button type="button" class="agreement-link" @click.stop.prevent="showAgreement('PRIVACY')">《隐私政策》</button>
          </el-checkbox>
        </div>
        <el-button class="submit-button" type="primary" native-type="submit" :loading="loading">注册</el-button>
      </el-form>
    </div>

    <el-dialog
      :visible.sync="agreementVisible"
      :title="agreementTitle"
      width="680px"
      custom-class="front-agreement-dialog"
      append-to-body
      :close-on-click-modal="false"
      @closed="agreementClosed"
    >
      <div v-loading="agreementLoading" class="agreement-dialog-content">
        <div v-if="agreementError" class="agreement-dialog-state">{{ agreementError }}</div>
        <div v-else-if="agreementContent" class="rich-content" v-html="safeHtml(agreementContent)"></div>
        <div v-else-if="!agreementLoading" class="agreement-dialog-state">协议内容暂未发布</div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { safeHtml } from '@/utils/sanitize'

export default {
  data() {
    return {
      visible: false,
      loading: false,
      codeLoading: false,
      codeCountdown: 0,
      codeTimer: null,
      isRegister: false,
      isForgot: false,
      loginMode: 'code',
      agreed: false,
      form: this.emptyForm(),
      agreementVisible: false,
      agreementLoading: false,
      agreementOpened: false,
      agreementType: 'USER',
      agreementTitle: '用户协议',
      agreementContent: '',
      agreementError: '',
    }
  },
  watch: {
    visible(value) { this.$emit('visibility-change', value) },
  },
  computed: {
    codeButtonText() { return this.codeCountdown > 0 ? this.codeCountdown + '秒后重试' : '获取验证码' },
  },
  beforeDestroy() { this.clearCodeTimer() },
  methods: {
    safeHtml,
    emptyForm() {
      return { phone: '', code: '', password: '', confirmPassword: '' }
    },
    open(mode) {
      this.reset()
      this.isRegister = mode === 'register'
      this.isForgot = false
      this.loginMode = 'code'
      this.visible = true
    },
    alignDialog() {
      this.$nextTick(() => {
        const dialog = document.querySelector('.front-auth-dialog')
        const wrapper = dialog && dialog.parentElement
        if (wrapper) wrapper.classList.add('front-auth-modal-wrapper')
      })
    },
    switchPanel(register) {
      this.reset()
      this.isRegister = register
      this.isForgot = false
      this.loginMode = 'code'
    },
    reset() {
      this.loading = false
      this.codeLoading = false
      this.clearCodeTimer()
      this.agreed = false
      this.form = this.emptyForm()
    },
    clearCodeTimer() {
      if (this.codeTimer) window.clearInterval(this.codeTimer)
      this.codeTimer = null
      this.codeCountdown = 0
    },
    startCodeCountdown() {
      this.clearCodeTimer()
      this.codeCountdown = 60
      this.codeTimer = window.setInterval(() => {
        this.codeCountdown--
        if (this.codeCountdown <= 0) this.clearCodeTimer()
      }, 1000)
    },
    async showAgreement(type) {
      const titles = { USER: '用户协议', PRIVACY: '隐私政策' }
      this.agreementType = type
      this.agreementTitle = titles[type] || titles.USER
      this.agreementContent = ''
      this.agreementError = ''
      this.agreementOpened = true
      this.agreementLoading = true
      this.agreementVisible = true
      try {
        const response = await this.$api('/api/website/agreements/' + this.agreementType, 'get')
        this.agreementContent = response.data && response.data.content ? response.data.content : ''
      } catch (error) {
        this.agreementError = /\u5c1a\u672a\u53d1\u5e03|\u4e0d\u5b58\u5728/.test(error.message || '') ? '该协议内容暂未发布' : '协议内容暂时无法加载，请稍后重试'
      } finally {
        this.agreementLoading = false
      }
    },
    agreementClosed() {
      // 用户从协议弹窗返回登录/注册表单后，按稿将同意项置为已勾选。
      if (this.agreementOpened) this.agreed = true
      this.agreementOpened = false
    },
    showForgotPassword() {
      const phone = this.form.phone
      this.reset()
      this.form.phone = phone
      this.isRegister = false
      this.isForgot = true
    },
    async sendCode() {
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.warning('请先填写有效的手机号')
        return
      }
      const scene = this.isForgot ? 'RESET_PASSWORD' : (this.isRegister ? 'REGISTER' : 'LOGIN')
      this.codeLoading = true
      try {
        await this.$api('/api/website/auth/sms/code', 'post', { phone: this.form.phone, scene })
        this.startCodeCountdown()
        this.$message.success('验证码已发送，请注意查收')
      } catch (error) {
        // request 拦截器统一展示服务端或短信供应商错误。
      } finally {
        this.codeLoading = false
      }
    },
    validatePassword() {
      return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/.test(this.form.password)
    },
    async submitForgot() {
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) return this.$message.warning('请填写有效手机号')
      if (!/^\d{6}$/.test(this.form.code)) return this.$message.warning('请填写6位数字验证码')
      if (!this.validatePassword()) return this.$message.warning('密码需为 8–20 位字母与数字组合')
      if (this.form.password !== this.form.confirmPassword) return this.$message.warning('两次输入的密码不一致')
      this.loading = true
      try {
        await this.$api('/api/website/auth/password/reset', 'post', {
          phone: this.form.phone,
          code: this.form.code,
          newPassword: this.form.password,
        })
        const phone = this.form.phone
        this.$message.success('密码已重置，请使用新密码登录')
        this.switchPanel(false)
        this.loginMode = 'password'
        this.form.phone = phone
      } catch (error) {
        // request 拦截器已展示服务端校验错误。
      } finally {
        this.loading = false
      }
    },
    async submit() {
      if (!this.agreed) {
        this.$message.warning('请先同意《用户协议》和《隐私政策》')
        return
      }
      if (this.isRegister) {
        if (!/^1[3-9]\d{9}$/.test(this.form.phone)) return this.$message.warning('请填写有效手机号')
        if (!/^\d{6}$/.test(this.form.code)) return this.$message.warning('请填写6位数字验证码')
        if (!this.validatePassword()) return this.$message.warning('密码需为 8–20 位字母与数字组合')
        if (this.form.password !== this.form.confirmPassword) return this.$message.warning('两次输入的密码不一致')
      } else {
        if (!this.form.phone) return this.$message.warning('请填写手机号或账号')
        if (this.loginMode === 'code') {
          if (!/^1[3-9]\d{9}$/.test(this.form.phone)) return this.$message.warning('请填写有效手机号')
          if (!/^\d{6}$/.test(this.form.code)) return this.$message.warning('请填写6位数字验证码')
        } else if (!this.form.password) return this.$message.warning('请输入密码')
      }

      this.loading = true
      try {
        if (this.isRegister) {
          await this.$api('/api/website/auth/register', 'post', {
            phone: this.form.phone,
            code: this.form.code,
            password: this.form.password,
          })
          this.$message.success('注册成功，请使用密码登录')
          this.switchPanel(false)
          this.loginMode = 'password'
        } else {
          const loginPath = this.loginMode === 'code' ? '/api/website/auth/login/code' : '/api/website/auth/login'
          const payload = this.loginMode === 'code' ? { phone: this.form.phone, code: this.form.code } : { phone: this.form.phone, password: this.form.password }
          const res = await this.$api(loginPath, 'post', payload)
          localStorage.setItem('front_token', res.token)
          window.dispatchEvent(new Event('auth-changed'))
          this.visible = false
          this.$emit('success')
          this.$message.success('登录成功')
          window.dispatchEvent(new Event('front-login-success'))
        }
      } catch (e) {
        // request 拦截器已负责展示后端错误，这里只结束 loading 状态。
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="less">
::v-deep .front-auth-dialog{width:460px!important;max-width:calc(100vw - 28px);max-height:calc(100vh - 24px);border-radius:12px;overflow:hidden;background:#fff;box-shadow:0 18px 48px rgba(15,35,79,.22)}
::v-deep .front-auth-dialog .el-dialog__header{display:none}
::v-deep .front-auth-dialog .el-dialog__body{padding:34px;max-height:calc(100vh - 24px);overflow-y:auto;box-sizing:border-box}
.dialog-close{position:absolute;right:7px;top:9px;border:0;background:transparent;color:#7b8492;font-size:25px;line-height:43px;cursor:pointer;padding:0;z-index:2}
.auth-panel{padding:0}.auth-heading{display:flex;align-items:center;gap:13px;height:62px;margin:0}.auth-heading img{display:block;width:50px;height:50px;object-fit:contain}.auth-heading h2{margin:0;color:#202020;font-size:22px;line-height:38px;font-weight:700}.auth-heading p{margin:0;color:#89939f;font-size:14px;line-height:24px}.register-panel .auth-heading h2{font-weight:400}
.forgot-panel{padding-bottom:15px}.forgot-title{height:38px;margin:0 0 24px;color:#202020;font-size:22px;font-weight:600;line-height:38px}.forgot-form ::v-deep .el-form-item{margin-bottom:10px}.forgot-submit{height:49px;margin-top:2px}
.auth-tabs{display:flex;height:50px;border-bottom:1px solid #edf0f5;margin-top:26px;margin-bottom:20px}.auth-tabs button{position:relative;flex:1;height:49px;border:0;background:transparent;color:#202020;font-size:16px;line-height:28px;cursor:pointer}.auth-tabs button.active{color:#2867e9;font-weight:400}.auth-tabs button.active:after{content:'';position:absolute;left:50%;bottom:-1px;width:94px;height:3px;transform:translateX(-50%);background:#2867e9;border-radius:2px}
.auth-form{font-size:14px}.auth-form ::v-deep .el-form-item{height:74px;margin:0 0 16px}.auth-form ::v-deep .el-form-item__label{display:block;float:none;width:auto!important;height:24px;line-height:24px;padding:0;color:#4f5966;font-size:14px;text-align:left}.auth-form ::v-deep .el-form-item__content{height:44px;margin-left:0!important;line-height:44px}.auth-form ::v-deep .el-input__inner,.grade-select ::v-deep .el-input__inner{height:44px;line-height:44px;padding:0 12px;border:1px solid #dce3ed;border-radius:9px;color:#313d52;font-size:16px}.auth-form ::v-deep .el-input__inner::placeholder{color:#757575}.code-row{display:flex;gap:10px}.code-row .el-input{flex:1;min-width:0}.code-button{width:104px;height:44px;padding:0;border:1px solid #b9ccef;color:#2867e9;background:#f3f7ff;font-size:14px;line-height:24px;border-radius:9px}.code-button.is-disabled{color:#9aa8bf;background:#f7f8fb}.agreement-row{display:flex;align-items:center;justify-content:space-between;gap:6px;height:24px;min-height:24px;margin:0 0 16px}.agreement-row ::v-deep .el-checkbox{display:flex;align-items:center;min-width:0;height:24px}.agreement-row ::v-deep .el-checkbox__label{padding-left:6px;color:#707780;font-size:13px;line-height:22px;white-space:nowrap}.agreement-row ::v-deep .el-checkbox__inner{width:13px;height:13px;border-radius:2px}.agreement-row ::v-deep .el-checkbox__inner:after{left:4px;top:1px;width:3px;height:7px}.agreement-row a,.forgot-link,.switch-tip button{border:0;background:transparent;color:inherit;cursor:pointer;font-size:inherit;padding:0}.forgot-link{color:#2867e9;font-size:13px;white-space:nowrap}.submit-button{width:100%;height:49px;border:0;border-radius:10px;background:linear-gradient(135deg,#2867e9 0%,#398cff 100%);box-shadow:0 7px 16px rgba(40,103,233,.18);font-size:16px;font-weight:600}.switch-tip{text-align:center;margin:9px 0 0;color:#2867e9;font-size:13px;line-height:22px}.register-panel .auth-form{margin-top:17px}.register-panel .auth-form ::v-deep .el-form-item{margin-bottom:16px}.register-panel .agreement-row{margin-top:0;margin-bottom:30px}.register-panel .submit-button{height:58px;border-radius:0}.grade-select{width:100%}
/* 注册稿的表单从标题下方再留出 20px 内间距，按钮与设计稿保持圆角。 */
.register-panel{padding-bottom:24px}.register-panel .auth-form{margin-top:37px}.register-panel .submit-button{border-radius:10px}
.agreement-link{border:0;background:transparent;color:#2867e9;cursor:pointer;font-size:inherit;padding:0;text-decoration:none}
@media(max-width:420px){::v-deep .front-auth-dialog .el-dialog__body{padding:24px 20px;max-height:calc(100vh - 24px)}.auth-heading h2{font-size:20px}.auth-heading p{font-size:12px}.forgot-title{font-size:20px}.auth-tabs{margin-top:20px}.auth-tabs button{font-size:14px}.auth-form ::v-deep .el-input__inner,.grade-select ::v-deep .el-input__inner{font-size:14px}.agreement-row ::v-deep .el-checkbox__label{font-size:11px}.forgot-link{font-size:11px}}
</style>

<style lang="less">
/* 可见时用 flex 居中；不要覆盖 Element UI 关闭时写入的内联 display:none。 */
.front-auth-modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 12px;
}
.front-auth-modal-wrapper .front-auth-dialog {
  margin: 0 auto !important;
}

.front-agreement-dialog {
  max-width: calc(100vw - 28px);
  border-radius: 12px;
  overflow: hidden;
}
.front-agreement-dialog .el-dialog__header {
  padding: 22px 28px 16px;
  border-bottom: 1px solid #edf1f6;
}
.front-agreement-dialog .el-dialog__title {
  color: #25344d;
  font-size: 20px;
  font-weight: 600;
}
.front-agreement-dialog .el-dialog__headerbtn {
  top: 22px;
  right: 24px;
}
.front-agreement-dialog .el-dialog__body {
  max-height: min(62vh, 560px);
  padding: 24px 28px 30px;
  overflow-y: auto;
}
.agreement-dialog-content {
  min-height: 120px;
  color: #3f4c60;
  font-size: 15px;
  line-height: 1.9;
}
.agreement-dialog-state {
  padding: 46px 12px;
  color: #8996a9;
  text-align: center;
}
@media (max-width: 600px) {
  .front-agreement-dialog .el-dialog__header { padding: 18px 20px 14px; }
  .front-agreement-dialog .el-dialog__body { padding: 18px 20px 24px; }
  .agreement-dialog-content { font-size: 14px; }
}
</style>
